// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gambar-sebelumnya[data-v-560990b8]{box-sizing:border-box;transition:all .2s ease;margin-top:50px;margin-bottom:40px;height:250px;width:100%;border-radius:4px;background-size:contain;background-position:50%;background-repeat:no-repeat;background-color:#fff;overflow:auto;padding:15px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
